<template>
  <div class="voucher-list">
    <h6 class="voucher-list__title">My Vouchers</h6>
    <div class="voucher-list__list-container">
      <VouchersListItem
        v-for="voucher in vouchers"
        :key="voucher.id"
        :voucher="voucher"
        @extend-voucher="openExtendModal"
      />
    </div>
    <p class="voucher-list__bottom">
      <span class="voucher-list__bottom-copy"
        >Not seeing the voucher you’d like to extend in the list above?</span
      >
      <span>
        You can purchase a 90 day extension for vouchers not listed
        <a class="voucher-list__bottom-cta" @click="openGenericModal"> here</a
        >.</span
      >
    </p>
    <a :href="`//${checkoutUrl}`" class="voucher-list__get">
      <div class="voucher-list__icon-wrapper">
        <PlusSymbolIcon class="voucher-list__plus-icon" />
      </div>
      <p class="voucher-list__get-vouchers">GET Vouchers</p>
    </a>
    <ExtendVoucherModal
      v-if="isExtendModalOpen"
      v-bind="extendVoucherModalBindings"
      @close="isExtendModalOpen = false"
    />
  </div>
</template>

<script>
import VouchersListItem from '@/components/user-dashboard/certifications/VouchersListItem.vue'
import PlusSymbolIcon from '@/assets/icons/plus_symbol_icon.svg'
import ExtendVoucherModal from '@/components/modals/ExtendVoucherModal.vue'
export default {
  name: 'VouchersList',
  components: {
    VouchersListItem,
    ExtendVoucherModal,
    PlusSymbolIcon: { ...PlusSymbolIcon, name: 'PlusSymbolIcon' },
  },
  props: {
    vouchers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isExtendModalOpen: false,
      checkoutUrl: process.env.VUE_APP_CHECKOUT_URL,
      extendVoucherModalBindings: {},
    }
  },
  methods: {
    openExtendModal({
      isExternal,
      certificateName,
      voucherId,
      cancelCallback = () => {},
    }) {
      this.extendVoucherModalBindings = {
        showWarning: isExternal,
        certificateName,
        voucherId,
        cancelCallback,
      }
      this.isExtendModalOpen = true
    },
    openGenericModal() {
      this.extendVoucherModalBindings = { showWarning: true }
      this.isExtendModalOpen = true
    },
  },
}
</script>

<style lang="scss">
.voucher-list {
  &__title {
    font-size: rem(24);
    line-height: 32px;
    color: var(--white);
    padding: 0;
    margin: 30px 0;
    width: 100%;
  }
  &__get {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
    flex-grow: 1;
    color: var(--white);
    padding: 3%;
    width: 100%;
    border: 1px dashed var(--perfect-gray);
    &:hover {
      opacity: 0.8;
    }
  }
  &__get-vouchers {
    text-transform: uppercase;
    font-size: rem(12);
    font-weight: bold;
    line-height: 14px;
    color: var(--perfect-gray);
    margin: 10px 0px;
  }
  &__list-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  &__bottom {
    display: flex;
    flex-direction: column;
    color: var(--light-blue-gray, #afb0bf);
    margin: 60px 0;
    text-align: center;
    font-size: 16px;
    font-weight: 450;
    line-height: 24px;
    &-cta {
      color: var(--purple-pale, #c9bbff);
      &:hover {
        color: var(--purple-dark);
        cursor: pointer;
      }
    }
    &-copy {
      color: var(--white);
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      line-height: 26px;
    }
  }
}
</style>
